"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var APIErrorType;
(function (APIErrorType) {
    APIErrorType["InvalidParameters"] = "InvalidParametersError";
    APIErrorType["InvalidSubscriptionError"] = "InvalidSubscriptionError";
    APIErrorType["PaymentInfoMissingError"] = "PaymentInfoMissingError";
    APIErrorType["AlreadyExists"] = "ResourceAlreadyExists";
    APIErrorType["InvalidGoogleToken"] = "InvalidGoogleToken";
    APIErrorType["InvalidFacebookToken"] = "InvalidFacebookToken";
    APIErrorType["InvalidLogin"] = "InvalidLoginError";
    APIErrorType["ResourceNotFound"] = "ResourceNotFound";
    APIErrorType["NotAccessibleError"] = "NotAccessibleError";
    APIErrorType["UnknownError"] = "UnknownError";
    APIErrorType["NetworkError"] = "NetworkError";
    APIErrorType["MissingAuthorizationError"] = "MissingAuthorizationError";
    APIErrorType["SessionNotFoundError"] = "SessionNotFoundError";
    APIErrorType["DownloadLimitReachedError"] = "DownloadLimitReachedError";
    APIErrorType["NotVerifiedError"] = "NotVerifiedError";
})(APIErrorType = exports.APIErrorType || (exports.APIErrorType = {}));
var SubscriptionInfo;
(function (SubscriptionInfo) {
    SubscriptionInfo[SubscriptionInfo["None"] = 0] = "None";
    SubscriptionInfo[SubscriptionInfo["Standard"] = 1] = "Standard";
    SubscriptionInfo[SubscriptionInfo["Premium"] = 2] = "Premium";
    SubscriptionInfo[SubscriptionInfo["Pro"] = 3] = "Pro";
})(SubscriptionInfo = exports.SubscriptionInfo || (exports.SubscriptionInfo = {}));
function errorToString(err, defaultMessage = 'An unhandled error occurred. Please try again later.') {
    if (err && err.type == 'InvalidParametersError') {
        if (err.missing_keys && err.missing_keys.length) {
            return err.missing_keys.map(k => k + ' is missing');
        }
        return Object.keys(err.invalid_keys).map((key) => {
            return key + ': ' + err.invalid_keys[key];
        });
    }
    else if (err && err.type == 'ResourceAlreadyExists' || err && err.message) {
        return [err.message];
    }
    else {
        return [defaultMessage];
    }
}
exports.errorToString = errorToString;



//////////////////
// WEBPACK FOOTER
// ./node_modules/bpm-client-api/lib/errors.js
// module id = 261
// module chunks = 0